export const getImage = (logo) => {
  try {
    // Dynamically resolve the logo path
    return require(`../../../../Assets/Images/${logo}.png`);
  } catch (error) {
    console.error(`Error loading image: ${logo}`, error);
    // Return a default logo if the specific one is not found
    // return require("../../../Assets/Images/soc_2.jpeg");
  }
};
